class SizeTabSwitcher extends HTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('[data-tab]'));
    this.panels = Array.from(
      this.closest('.product-popup-modal__content').querySelectorAll('[data-tab-panel]')
    );

    this.buttons.forEach((btn) => {
      btn.addEventListener('click', () => this.switchTab(btn.dataset.tab));
    });
  }

  switchTab(tab) {
    this.buttons.forEach((btn) => {
      btn.classList.toggle('is-active', btn.dataset.tab === tab);
    });

    this.panels.forEach((panel) => {
      panel.classList.toggle('is-active', panel.dataset.tabPanel === tab);
    });
  }
}

customElements.define('size-tab-switcher', SizeTabSwitcher);

// class SizeChartPDP extends HTMLElement {
//   static SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'];

//   connectedCallback() {
//     this.submitBtn = this.querySelector('.calculate-my-size__submit');
//     this.resultEl = this.querySelector('.calculate-my-size__result');

//     this.ageInput = this.querySelector('[name="age"]');
//     this.heightInput = this.querySelector('[name="height"]');
//     this.weightInput = this.querySelector('[name="weight"]');
//     this.chestInput = this.querySelector('[name="chest"]');
//     this.fitRadios = Array.from(this.querySelectorAll('input[name="fit_preference"]'));

//     this.availableSizes = this.parseJSON(this.dataset.availableSizes, []);

//     this.submitBtn?.addEventListener('click', () => this.showResult());

//     this.resultEl?.addEventListener('click', (e) => {
//       const shopBtn = e.target.closest('[data-shop-now]');
//       if (shopBtn) this.selectSize(shopBtn.dataset.shopNow);
//     });

//     [this.ageInput, this.heightInput, this.weightInput, this.chestInput].forEach((input) => {
//       input?.addEventListener('input', () => this.toggleSubmit());
//     });
//   }

//   toggleSubmit() {
//     const allFilled = [this.ageInput, this.heightInput, this.weightInput, this.chestInput].every(
//       (input) => input && input.value !== ''
//     );
//     if (this.submitBtn) {
//       this.submitBtn.disabled = !allFilled;
//     }
//   }

//   parseJSON(value, fallback) {
//     try {
//       return value ? JSON.parse(value) : fallback;
//     } catch (e) {
//       return fallback;
//     }
//   }

//   // ---- Sizing logic: sequential bracket walk through chest measurement,
//   // normalized to standard retail dimensions, and modified via mass indices. ----

//   calculateSize() {
//     const age = Number(this.ageInput.value);
//     const height = Number(this.heightInput.value);
//     const weight = Number(this.weightInput.value);
//     const chestInput = Number(this.chestInput.value);
//     const fitPreference = (this.fitRadios.find((r) => r.checked) || {}).value || 'true_to_size';

//     if (!age || !height || !weight || !chestInput) return null;

//     // 1. Core Industry Baseline Bracket Segmentation (Chest Circumference)
//     let size;
//     if (chestInput < 78) size = 'XXS';
//     else if (chestInput < 83) size = 'XS';
//     else if (chestInput < 88) size = 'S';
//     else if (chestInput < 93) size = 'M';
//     else if (chestInput < 99) size = 'L';
//     else if (chestInput < 106) size = 'XL';
//     else size = 'XXL';

//     // 2. Mass-to-Height Ratio Evaluation (Resolves frame volume and broadness errors)
//     const massToHeightRatio = weight / (height / 100); 
    
//     if (massToHeightRatio > 50 && size !== 'XXL') {
//       size = this.stepUp(size);
//     } else if (massToHeightRatio < 33 && size !== 'XXS') {
//       size = this.stepDown(size);
//     }

//     // 3. Demographic Patterns Adjustments
//     if (age < 18) size = this.stepDown(size);
//     else if (age >= 55) size = this.stepUp(size);

//     // 4. Silhouette Compression/Fit Nudges
//     if (fitPreference === 'tight') size = this.stepDown(size);
//     else if (fitPreference === 'loose') size = this.stepUp(size);

//     return this.clampToAvailable(size);
//   }

//   stepUp(size) {
//     const index = SizeChartPDP.SIZE_ORDER.indexOf(size);
//     if (index === -1 || index === SizeChartPDP.SIZE_ORDER.length - 1) return size;
//     return SizeChartPDP.SIZE_ORDER[index + 1];
//   }

//   stepDown(size) {
//     const index = SizeChartPDP.SIZE_ORDER.indexOf(size);
//     if (index <= 0) return size;
//     return SizeChartPDP.SIZE_ORDER[index - 1];
//   }

//   clampToAvailable(size) {
//     if (!this.availableSizes.length) return size;
//     if (this.availableSizes.includes(size)) return size;

//     const index = SizeChartPDP.SIZE_ORDER.indexOf(size);
//     for (let distance = 1; distance < SizeChartPDP.SIZE_ORDER.length; distance++) {
//       const up = SizeChartPDP.SIZE_ORDER[index + distance];
//       const down = SizeChartPDP.SIZE_ORDER[index - distance];
//       if (up && this.availableSizes.includes(up)) return up;
//       if (down && this.availableSizes.includes(down)) return down;
//     }
//     return size;
//   }

//   // ---- Result + PDP integration ----

//   showResult() {
//     const size = this.calculateSize();

//     if (!size) {
//       this.resultEl.hidden = false;
//       this.resultEl.innerHTML = `<div class="calculate-my-size__error">Please fill in all fields.</div>`;
//       return;
//     }

//     this.resultEl.hidden = false;
//     this.resultEl.innerHTML = `
//       <div class="calculate-my-size__result-size">Your size: <strong>${size}</strong></div>
//       <button type="button" class="calculate-my-size__shop-now" data-shop-now="${size}">Shop Now</button>
//     `;
//   }

//   selectSize(size) {
//     const variantPicker = document.querySelector('variant-radios, variant-selects');
//     if (!variantPicker) return;

//     const radio = variantPicker.querySelector(`input[name="Size"][value="${size}"]`);
//     if (!radio) {
//       this.showUnavailableNotice(size);
//       return;
//     }

//     radio.checked = true;
//     radio.dispatchEvent(new Event('change', { bubbles: true }));

//     this.closeParentModal();
//     this.scrollToAddToCart();
//   }

//   showUnavailableNotice(size) {
//     const notice = document.createElement('div');
//     notice.className = 'calculate-my-size__notice';
//     notice.textContent = `Size ${size} isn't available as an option on this product.`;
//     this.resultEl.appendChild(notice);
//   }

//   closeParentModal() {
//     const modal = this.closest('modal-dialog');
//     if (modal && typeof modal.hide === 'function') {
//       modal.hide();
//     } else if (modal) {
//       const closeBtn = modal.querySelector('[id^="ModalClose-"]');
//       if (closeBtn) closeBtn.click();
//     }
//   }

//   scrollToAddToCart() {
//     const addToCartForm = document.querySelector('[id^="product-form-"]');
//     if (addToCartForm) {
//       addToCartForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
//     }
//   }
// }

// customElements.get('size-chart-pdp') || customElements.define('size-chart-pdp', SizeChartPDP);

class SizeChartPDP extends HTMLElement {
  static SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL'];

  connectedCallback() {
    this.submitBtn = this.querySelector('.calculate-my-size__submit');
    this.resultEl = this.querySelector('.calculate-my-size__result');
    this.fitRadios = Array.from(this.querySelectorAll('input[name="fit_preference"]'));

    this.inputs = {};
    this.querySelectorAll('.calculate-my-size__fields [name]').forEach((el) => {
      this.inputs[el.name] = el;
    });

    this.availableSizes = this.parseJSON(this.dataset.availableSizes, []);
    this.criteria = this.parseJSON(this.dataset.sizeCriteria, null);

    this.submitBtn?.addEventListener('click', () => this.showResult());

    this.resultEl?.addEventListener('click', (e) => {
      const shopBtn = e.target.closest('[data-shop-now]');
      if (shopBtn) this.selectSize(shopBtn.dataset.shopNow);
    });

    Object.values(this.inputs).forEach((input) => {
      input.addEventListener('input', () => this.toggleSubmit());
    });
  }

  toggleSubmit() {
    const allFilled = Object.values(this.inputs).every((input) => input.value !== '');
    if (this.submitBtn) this.submitBtn.disabled = !allFilled;
  }

  parseJSON(value, fallback) {
    try {
      return value ? JSON.parse(value) : fallback;
    } catch (e) {
      return fallback;
    }
  }

  buildContext() {
    const context = {};
    Object.entries(this.inputs).forEach(([name, el]) => {
      context[name] = Number(el.value);
    });
    const checkedFit = this.fitRadios.find((r) => r.checked);
    context.fit_preference = checkedFit ? checkedFit.value : 'true_to_size';
    return context;
  }

  ruleMatches(conditions, context) {
    return Object.entries(conditions).every(([key, value]) => {
      if (key === 'size' || key === 'weight') return true;
      if (key.endsWith('Min')) {
        const field = key.slice(0, -3);
        return context[field] !== undefined && context[field] >= value;
      }
      if (key.endsWith('Max')) {
        const field = key.slice(0, -3);
        return context[field] !== undefined && context[field] < value;
      }
      return context[key] === value;
    });
  }

  matchRules(rules, context) {
    const found = rules.find((rule) => this.ruleMatches(rule, context));
    return found ? found.size : null;
  }

  computeStep(context) {
    let score = 0;

    const ageRow = (this.criteria.ageWeight || []).find((row) => this.ruleMatches(row, context));
    if (ageRow) score += ageRow.weight;

    const fitWeights = this.criteria.fitWeight || {};
    if (context.fit_preference && fitWeights[context.fit_preference] !== undefined) {
      score += fitWeights[context.fit_preference];
    }

    return Math.max(-1, Math.min(1, Math.round(score)));
  }

  calculateSize() {
    if (!this.criteria || !this.criteria.rules || !this.criteria.primaryField) return null;

    const context = this.buildContext();

    const allValid = Object.entries(this.inputs).every(([name]) => {
      return !Number.isNaN(context[name]) && context[name] !== 0 || context[name] > 0;
    });
    if (!allValid) return null;

    const primaryValue = context[this.criteria.primaryField];
    if (!primaryValue) return null;

    const baseSize = this.matchRules(this.criteria.rules, context);
    if (!baseSize) return null;

    const step = this.computeStep(context);
    const adjusted = this.shiftSize(baseSize, step);

    return this.clampToAvailable(adjusted);
  }

  shiftSize(size, step) {
    const index = SizeChartPDP.SIZE_ORDER.indexOf(size);
    if (index === -1) return size;
    const newIndex = Math.min(Math.max(index + step, 0), SizeChartPDP.SIZE_ORDER.length - 1);
    return SizeChartPDP.SIZE_ORDER[newIndex];
  }

  clampToAvailable(size) {
    if (!this.availableSizes.length) return size;
    if (this.availableSizes.includes(size)) return size;

    const index = SizeChartPDP.SIZE_ORDER.indexOf(size);
    for (let distance = 1; distance < SizeChartPDP.SIZE_ORDER.length; distance++) {
      const up = SizeChartPDP.SIZE_ORDER[index + distance];
      const down = SizeChartPDP.SIZE_ORDER[index - distance];
      if (up && this.availableSizes.includes(up)) return up;
      if (down && this.availableSizes.includes(down)) return down;
    }
    return size;
  }

  showResult() {
    const size = this.calculateSize();

    if (!size) {
      this.resultEl.hidden = false;
      this.resultEl.innerHTML = `<div class="calculate-my-size__error">Please fill in all fields.</div>`;
      return;
    }

    this.resultEl.hidden = false;
    this.resultEl.innerHTML = `
      <div class="calculate-my-size__result-size">Your size: <strong>${size}</strong></div>
      <button type="button" class="calculate-my-size__shop-now" data-shop-now="${size}">Shop Now</button>
    `;
  }

  selectSize(size) {
    const variantPicker = document.querySelector('variant-radios, variant-selects');
    if (!variantPicker) return;

    const radio = variantPicker.querySelector(`input[name="Size"][value="${size}"]`);
    if (!radio) {
      this.showUnavailableNotice(size);
      return;
    }

    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));

    this.closeParentModal();
    this.scrollToAddToCart();
  }

  showUnavailableNotice(size) {
    const notice = document.createElement('div');
    notice.className = 'calculate-my-size__notice';
    notice.textContent = `Size ${size} isn't available as an option on this product.`;
    this.resultEl.appendChild(notice);
  }

  closeParentModal() {
    const modal = this.closest('modal-dialog');
    if (modal && typeof modal.hide === 'function') {
      modal.hide();
    } else if (modal) {
      const closeBtn = modal.querySelector('[id^="ModalClose-"]');
      if (closeBtn) closeBtn.click();
    }
  }

  scrollToAddToCart() {
    const addToCartForm = document.querySelector('[id^="product-form-"]');
    if (addToCartForm) {
      addToCartForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
}

customElements.get('size-chart-pdp') || customElements.define('size-chart-pdp', SizeChartPDP);